import { v4 as uuidv4 } from 'uuid'
import { messagesAtom, store } from '../store'

export type Message = {
  id: string
  content: string
  variant: 'error' | 'success' | 'warning'
  timeout: NodeJS.Timeout
}

const getIfExist = (content: string, messages: Message[]) =>
  messages.find((m) => m.content === content)

export const add = (
  content: string,
  variant: 'error' | 'success' | 'warning' = 'warning',
  duration = 5
) => {
  store.set(messagesAtom, (messages) => {
    const message = getIfExist(content, messages)
    if (message) {
      clearTimeout(message.timeout)
      const timeout = setTimeout(() => remove(message.id), duration * 1000)
      return messages.map((m) => (m.id === message.id ? { ...m, timeout } : m))
    } else {
      const id = uuidv4()
      const timeout = setTimeout(() => remove(id), duration * 1000)
      return [...messages, { id, content, variant, timeout }]
    }
  })
}

export const remove = (id: string) =>
  store.set(messagesAtom, (messages) => messages.filter((m) => m.id !== id))

export const addError = (content: string, duration?: number) =>
  add(content, 'error', duration)

export const addWarning = (content: string, duration?: number) =>
  add(content, 'warning', duration)

export const addSuccess = (content: string, duration?: number) =>
  add(content, 'success', duration)

export default {
  add,
  addError,
  addWarning,
  addSuccess,
  remove,
}
